export default __webpack_public_path__ + "static/media/Minicard_Jd.45adf650.svg";